import React, { useEffect } from 'react';
import { PageNotFound } from '../../common/PageNotFound';
import { useSession } from '../../common/hooks';
import { ResetPasswordPage } from '../views/ResetPasswordPage';
import { SignInPage } from '../views/SignInPage';

type SignInControllerProps = {
  page: 'signin' | 'reset-password';
};

export const SignInController: React.FC<SignInControllerProps> = ({ page }) => {
  const { clearSession } = useSession();

  async function init() {
    await clearSession();
  }

  useEffect(() => {
    init();
  }, []);

  switch (page) {
    case 'signin':
      return <SignInPage />;
    case 'reset-password':
      return <ResetPasswordPage />;
    default:
      return <PageNotFound />;
  }
};
